// Map Styles
export const stateLine = {
    "id": "stateLines",
    "source": "counties",
    "type": "line",
    "minzoom": 0,
    "maxzoom": 22,
    "layout": {
        "visibility": "visible"
    },
    "paint": {
        "line-blur": 1,
        "line-color": "#003862",
        "line-width": 2,
        "line-opacity": 1
    }
};
export const stateFill = {
    "id": "stateFills",
    "type": "fill",
    "source": "counties",
    "paint": {
        "fill-color": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            "hsla(208, 30%, 18%, 1)",
            7,
            "hsla(208, 30%, 18%, 0.9)",
            15,
            "hsla(208, 30%, 18%, 0.8)",
            20,
            "hsla(208, 30%, 18%, 0.3)"
        ],
        "fill-opacity": 1,
    }
};
export const countyLine = {
    "id": "countyLines",
    "source": "counties",
    "type": "line",
    "minzoom": 0,
    "maxzoom": 22,
    "layout": {
        "visibility": "visible"
    },
    "paint": {
        "line-blur": 1,
        "line-color": "#003862",
        "line-width": 2,
        "line-opacity": 1
    }
};
export const countyFill = {
    "id": "countyFills",
    "type": "fill",
    "source": "counties",
    "paint": {
        "fill-color": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            "hsla(206, 100%, 29%, 1)",
            7,
            "hsla(206, 100%, 29%, 0.9)",
            15,
            "hsla(206, 100%, 29%, 0.8)",
            20,
            "hsla(206, 100%, 29%, 0.3)"
        ],
        "fill-opacity": 1,
    }
};
export const countyHover = {
    "id": "countyHover",
    "type": "fill",
    "source": "counties",
    "paint": {
        "fill-color": "#003862",
        "fill-opacity": 0.8,
    }
};
export const cityLine = {
    "id": "cityLines",
    "source": "cities",
    "type": "line",
    "minzoom": 0,
    "maxzoom": 22,
    "layout": {
        "visibility": "visible"
    },
    "paint": {
        "line-blur": 1,
        "line-color": "#003862",
        "line-width": 2,
        "line-opacity": 1
    }
};
export const cityFill = {
    "id": "cityFills",
    "type": "fill",
    "source": "cities",
    "paint": {
        "fill-color": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            "hsla(208, 30%, 18%, 0.9)",
            10,
            "hsla(208, 30%, 18%, 0.9)",
            12,
            "hsla(208, 30%, 18%, 0.3)"
        ],
        "fill-opacity": 1,
    }
};
export const cityHover = {
    "id": "cityHover",
    "type": "fill",
    "source": "cities",
    "paint": {
        "fill-color": "#659db3",
        "fill-opacity": 1,
    }
};
export const clusterLayer = {
    id: 'clusters',
    type: 'circle',
    source: 'resources',
    paint: {
        'circle-color': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            "#ffffff",
            6,
            "#ffffff",
            8,
            "#79bde9",
            12,
            "#79bde9"
        ],
        'circle-radius': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            2,
            6,
            2,
            10,
            10,
            15,
            10
        ]
    }
};
export const clusterCountLayer = {
    id: 'clusterCount',
    type: 'symbol',
    source: 'resources',
    paint: {
        'text-color': '#003862',
    },
    layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Bold', 'Arial Unicode MS Bold'],
        'text-size': 12,
    }
};
export const unclusteredPointLayer = {
    id: 'unclusteredPoints',
    type: 'circle',
    source: 'resources',
    filter: ['!', ['has', 'point_count']],
    paint: {
        'circle-color': '#79bde9',
        'circle-radius': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            2,
            6,
            2,
            10,
            8,
            15,
            8
        ],
        'circle-stroke-width': 1,
        'circle-stroke-color': '#79bde9'
    }
};
export const allPointLayer = {
    id: 'allPoints',
    type: 'circle',
    source: 'resources',
    filter: ['!', ['has', 'point_count']],
    paint: {
        'circle-color': '#79bde9',
        'circle-radius': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            2,
            6,
            2,
            10,
            8,
            15,
            8
        ],
        'circle-stroke-width': 0,
        'circle-stroke-color': '#79bde9'
    }
};
